import { buildPolygonStyle, POLYGON_UNSELECTED_COLOR } from 'lib/map';
import { Layer, Source } from 'react-map-gl';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- read only through `typeof STYLE` in the props type
const STYLE = buildPolygonStyle({ color: POLYGON_UNSELECTED_COLOR });

interface Props {
  geometry?: GeoJSON.Geometry;
  id: number | string;
  color?: string;
  style?: typeof STYLE;
}

const StructureGridPolygonArea = ({ geometry, id, color }: Props) => {
  return geometry &&
    ['Polygon', 'MultiPolygon', 'GeometryCollection'].includes(
      geometry.type
    ) ? (
    <Source
      type="geojson"
      data={{
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: geometry,
            properties: null,
            id: id,
          },
        ],
      }}
    >
      <Layer
        key={`line-${id}`}
        id={`polygon-line-${id}`}
        type="line"
        paint={{
          'line-color': color || '#42be65',
          'line-width': 2,
        }}
      />
    </Source>
  ) : null;
};

export default StructureGridPolygonArea;
